import v3ApiClient from "./client";

const AG_BASE_PATH = "/v3/ag";

export const agentGovernanceApi = {
    listEntityBindings: ({ entityType, entityIds, bindingStatus = "pending_review", limit }) =>
        v3ApiClient.get(`${AG_BASE_PATH}/entity-bindings`, {
            params: {
                entity_type: entityType,
                entity_ids: Array.isArray(entityIds) ? entityIds.join(",") : entityIds || undefined,
                binding_status: bindingStatus,
                limit,
            },
        }),

    getReviewCase: (reviewCaseId) =>
        v3ApiClient.get(`${AG_BASE_PATH}/review-cases/${reviewCaseId}`),

    submitDecision: (reviewCaseId, payload) =>
        v3ApiClient.post(`${AG_BASE_PATH}/review-cases/${reviewCaseId}/decisions`, payload),

    // ---- Master Data 表单填写（AG v3 同步 inline 通道） ----
    getMasterDataFormSchema: (formType, operationType = "CREATE") =>
        v3ApiClient.get(`${AG_BASE_PATH}/master-data/form-schema`, {
            params: { form_type: formType, operation_type: operationType },
        }),

    createMasterDataFormFillRequest: (params) =>
        v3ApiClient.post(`${AG_BASE_PATH}/requests/master-data/form-fill`, params, {
            timeout: 180000,
        }),

    submitInlineReviewCaseDecision: (reviewCaseId, params) =>
        v3ApiClient.post(`${AG_BASE_PATH}/review-cases/${reviewCaseId}/inline-decisions`, params),
};

export default agentGovernanceApi;
